"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _commonReact = require("@devsta/common-react");

require("../styles/_team-summary.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TeamSummary = /*#__PURE__*/function (_Component) {
  _inherits(TeamSummary, _Component);

  var _super = _createSuper(TeamSummary);

  function TeamSummary(props) {
    var _this;

    _classCallCheck(this, TeamSummary);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _lodash.default)(function () {
      var _this$props = _this.props,
          orgPermissions = _this$props.orgPermissions,
          deleteTeam = _this$props.deleteTeam,
          teamPreview = _this$props.teamPreview,
          onDeleteSuccess = _this$props.onDeleteSuccess,
          onClick = _this$props.onClick;
      var deleteAction = (0, _lodash.default)(function (teamId) {
        return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _yield$deleteTeam, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return deleteTeam({
                    teamId: teamId
                  });

                case 2:
                  _yield$deleteTeam = _context.sent;
                  error = _yield$deleteTeam.error;

                  if (!error) {
                    // Team deleted, update the teams state in ManageTeams
                    onDeleteSuccess(teamId);
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      });
      var actionOptions = [{
        action: onClick,
        label: 'Manage Users',
        requiredPermission: 'MANAGE_TEAM'
      }, {
        action: deleteAction(teamPreview.teamId),
        label: 'Delete Team',
        isRed: true,
        requiredPermission: 'MANAGE_TEAM'
      }];
      return actionOptions.filter(function (_ref2) {
        var requiredPermission = _ref2.requiredPermission;
        return !requiredPermission || (0, _commonReact.hasPermission)(requiredPermission, orgPermissions);
      });
    }));

    _this.state = {};
    return _this;
  }

  _createClass(TeamSummary, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          teamPreview = _this$props2.teamPreview,
          onClick = _this$props2.onClick;
      var name = teamPreview.name,
          description = teamPreview.description,
          membersPreview = teamPreview.membersPreview,
          membersCount = teamPreview.membersCount,
          type = teamPreview.type,
          imageUrl = teamPreview.imageUrl;
      return /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
        onClick: onClick,
        className: "team-summary",
        coverImageProps: {
          imageUrl: imageUrl,
          defaultImageIcon: 'group'
        },
        smallestCoverImage: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "team-summary__content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "team-summary__content__info"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        suffixIcon: type === 'EDITING' ? 'desktop' : void 0,
        heading4: true,
        noMargin: true
      }, name), description && /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        label: true
      }, description), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        noMargin: true
      }, "".concat(membersCount, " User").concat(membersCount !== 1 ? 's' : '')), /*#__PURE__*/_react.default.createElement(_uiKit.ResourceMembers, {
        members: membersPreview,
        totalMembers: membersCount,
        small: true
      })), /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
        options: this.getActionOptions()
      })));
    }
  }]);

  return TeamSummary;
}(_react.Component);

exports.default = TeamSummary;

_defineProperty(TeamSummary, "displayName", 'TeamSummary');